module.exports = __webpack_public_path__ + "static/img/dian1.3123457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/dian1.png
// module id = FpHh
// module chunks = 32